export default __webpack_public_path__ + "static/media/whatsapp.c7cb3ee9.svg";